import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';


const IconButton = props =>
  <button
    className={Classnames('button', 'icon-button', props.className, {
      'line-button': props.outline,
    })}
    style={{
      // Background color is allowed only for solid buttons.
      backgroundColor: !props.outline ? props.backgroundColor : null,

      // Border color is allowed only for line buttons.
      borderColor: props.outline ? props.borderColor : null,
      color: props.color,
    }}
    onClick={props.onClick}
  >
    {props.icon}
  </button>;

IconButton.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  outline: PropTypes.bool,
};

IconButton.defaultProps = {
  backgroundColor: null,
  borderColor: null,
  color: null,
  outline: false,
};

module.exports = IconButton;



// WEBPACK FOOTER //
// ./app/components/common/button/IconButton.jsx